import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type DeleteWorkflowRuleDefinitionMutationVariables = GraphQLTypes.Exact<{
  workflowRuleDefinitionId: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeleteWorkflowRuleDefinitionMutationResult = { __typename?: 'Mutation' } & {
  deleteWorkflowRuleDefinition?: GraphQLTypes.Maybe<
    { __typename?: 'DeleteWorkflowRuleDefinitionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DeleteWorkflowRuleDefinitionDocument = gql`
  mutation deleteWorkflowRuleDefinition($workflowRuleDefinitionId: String!) {
    deleteWorkflowRuleDefinition(workflowRuleDefinitionId: $workflowRuleDefinitionId) {
      errors {
        message
        path
      }
    }
  }
`;
